/**
 * ProtectedRoute - Wrapper for routes that require authentication
 */

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export const ProtectedRoute = ({ requireTeam = false, requiredRoles = [] }) => {
  const { user, loading, currentTeam } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireTeam && !currentTeam) {
    return <Navigate to="/teams" replace />;
  }

  if (requiredRoles.length > 0 && currentTeam) {
    const userRole = currentTeam.role;
    const hasPermission = requiredRoles.includes(userRole) || user.is_superadmin;

    if (!hasPermission) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          padding: '20px',
          textAlign: 'center'
        }}>
          <h2>Access Denied</h2>
          <p>You don't have permission to access this page.</p>
          <p>Required role: {requiredRoles.join(' or ')}</p>
          <p>Your role: {userRole}</p>
        </div>
      );
    }
  }

  return <Outlet />;
};

export default ProtectedRoute;
